// extracted by css-extract-rspack-plugin
module.exports =  {"warning":"BulkDelete__warning--uLA5o","importantWarning":"BulkDelete__importantWarning--r0GUb BulkDelete__warning--uLA5o"};